import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

import {getStatesByFlow} from '../../services/getStatesByFlow/getStatesByFlow';
import {GetStatesListParam, StatesProps} from '../../types';

export const useGetStatesByFlowQuery = (params: GetStatesListParam, enabled = true) =>
	useQuery<StatesProps[]>({
		queryKey: [QUERY_KEYS.STATE_BY_FLOW, params],
		queryFn: ({signal}) => getStatesByFlow({...params, signal}),
		enabled,
	});
